import { cncMiniLazyload } from '@default/scripts/modules/lazy-load/cncMiniLazyload';
import { LoadMore } from '@default/scripts/modules/load-more';

const GTM = {
    /** @param {Number} */
    send(pageNumber) {
        /* GTM 2.0 - dataLayer push "page" */
        if (window.dataLayer instanceof Array) {
            window.dataLayer.push({
                event: 'page_next',
                page: {
                    pagination: { page: pageNumber },
                    _clear: true,
                },
            });
        }
    },
    track() {
        if (window.gtmService && window.gtmService.observe instanceof Function) {
            window.gtmService.observe();
        }
    },
};

/**
 * @param {String} url
 * @param {String} param
 * @returns {Number}
 */
const getUrlParamValue = (url, param) => {
    const results = new RegExp(`[?&]${param}=([^&#]*)`).exec(url);

    return results ? parseInt(results[1], 10) : 2;
};

/** @param {NodeListOf<HTMLElement>} elements */
export const loadMore = (elements) => {
    [...elements].forEach((element) => {
        const { boxId, nextRequestUrl, urlParameter, loadingText } = element.dataset;

        if (!boxId) return;

        const placeholder = document.querySelector(`[data-load-more-placeholder="${boxId}"]`);

        /** @type {HTMLElement} */
        const errorMessageEl = document.querySelector(`[data-load-more-error="${boxId}"]`);

        new LoadMore(element, placeholder, {
            boxId,
            page: getUrlParamValue(nextRequestUrl, urlParameter),
            loading: loadingText,
        });

        element.addEventListener('load-more--before-load', (event) => {
            errorMessageEl.hidden = true;
            element.disabled = true;
            GTM.track();
            GTM.send(event.detail.pageNumber);
        });

        element.addEventListener('load-more--after-load', () => {
            element.disabled = false;
            GTM.track();
        });

        element.addEventListener('load-more--after-insert', () => {
            cncMiniLazyload();
        });

        element.addEventListener('load-more--error', () => {
            errorMessageEl.hidden = false;
        });
    });
};
